/**
 * PeopleGraph — API Client
 *
 * Replaces localStorage-based storage with fetch calls to the Express backend.
 * All requests include credentials for httpOnly cookie-based JWT auth.
 */

async function request(method, path, body) {
  const opts = {
    method,
    credentials: "include",
    headers: {},
  };
  if (body !== undefined) {
    opts.headers["Content-Type"] = "application/json";
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(path, opts);

  if (res.status === 401) {
    window.dispatchEvent(new Event("auth:expired"));
    throw new Error("Session expired");
  }

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.error || `Request failed: ${res.status}`);
  }

  return data;
}

export const api = {
  // Auth
  login: (email, password) =>
    request("POST", "/api/auth/login", { email, password }),
  register: (email, password, name, inviteCode) =>
    request("POST", "/api/auth/register", {
      email,
      password,
      name,
      inviteCode,
    }),
  logout: () => request("POST", "/api/auth/logout"),
  getMe: () => request("GET", "/api/auth/me"),

  // People CRUD
  getPeople: () => request("GET", "/api/people"),
  addPerson: (data) => request("POST", "/api/people", data),
  bulkAddPeople: (entries) => request("POST", "/api/people/bulk", { entries }),
  updatePerson: (id, data) => request("PUT", `/api/people/${id}`, data),
  deletePerson: (id) => request("DELETE", `/api/people/${id}`),

  // Backup
  exportBackup: () => request("GET", "/api/backup/export"),
  importBackup: (data, mode) =>
    request("POST", "/api/backup/import", { ...data, mode }),
};
